import { CloseIcon, saveBlueIcon } from '@/shared/ui/assets';
import { CustomButton, CustomTextarea } from '@/shared/ui/components';
import { ReactSVG } from 'react-svg';
import { t } from 'ttag';
import { useReturnStatusNotes } from './useReturnStatusNotes';
import type { ReturnStatusNotesProps } from './returnStatusNotes.types';
import './style.scss';

/**
 * Editable notes field of a study's return status tab. Binds a textarea to state.notes through onChangeInputText and, once isChangeNote reports an unsaved edit, reveals reset and save buttons wired to resetNotes and onSubmit, with every control disabled while state.isSaving.
 *
 * @param data - Study return data holding the persisted notes.
 * @param updateStudyDetail - Callback refreshing the study detail after a successful save.
 * @returns The notes editor markup.
 */
const ReturnStatusNotes = ({ data, updateStudyDetail }: ReturnStatusNotesProps) => {
  const { state, isChangeNote, resetNotes, onSubmit, onChangeInputText } = useReturnStatusNotes({
    data,
    updateStudyDetail,
  });

  return (
    <div className="return-status-notes">
      {isChangeNote && (
        <div className="selection__modifier">
          <CustomButton
            id="close-btn"
            icon={<ReactSVG src={CloseIcon} />}
            size="small"
            style="default"
            type="outline"
            disabled={state.isSaving}
            onClick={resetNotes}
            ariaLabel={t`Cancel`}
          />
          <CustomButton
            id="save-btn"
            icon={<ReactSVG src={saveBlueIcon} />}
            size="small"
            style="default"
            type="secondary"
            loading={state.isSaving}
            onClick={onSubmit}
            className="save-return-btn"
          >
            {t`Save`}
          </CustomButton>
        </div>
      )}
      <CustomTextarea
        inputClassName="selection__body-input"
        name="notes"
        value={state.notes}
        onChange={onChangeInputText}
        placeholder={t`Notes...`}
        disabled={state.isSaving}
        id="return-status-textarea"
      />
    </div>
  );
};

export default ReturnStatusNotes;
